import Loading from '../components/base/Loading';
import ModuleTile from '../components/tiles/ModuleTile';
import TilesGrid from '../components/tiles/TilesGrid';
import { useGetModulesForCompanyQuery } from '../graphql/schema';

const Modules = () => {
  const { data, loading } = useGetModulesForCompanyQuery();

  return (
    <TilesGrid loading={loading}>
      {data?.modulesForCompany
        .map((m) => m)
        .sort((a, b) => a.title.localeCompare(b.title))
        .map((module) => (
          <ModuleTile module={module} key={module.id} />
        ))}
    </TilesGrid>
  );
};

export default Modules;
